import type { ApiClient, RequestOptions } from './client';
import type { ChatRequestBody, ChatStreamEvent } from '@/types/chat';
import { parseSseStream } from '@/streaming/sse-parser';

export interface ChatStreamApi {
  stream: (body: ChatRequestBody, options?: RequestOptions) => AsyncGenerator<ChatStreamEvent>;
}

export function createChatStreamApi(client: ApiClient): ChatStreamApi {
  return {
    async *stream(body, options): AsyncGenerator<ChatStreamEvent> {
      const response = await client.postRaw('/api/chat/messages?stream=true', body, {
        ...options,
        accept: 'text/event-stream',
      });

      if (!response.body) return;

      for await (const frame of parseSseStream(response.body)) {
        const parsed = parseEvent(frame.event, frame.data);
        if (parsed) yield parsed;
        if (parsed?.event === 'done' || parsed?.event === 'error') return;
      }
    },
  };
}

function parseEvent(event: string, data: string): ChatStreamEvent | null {
  let payload: unknown;
  try {
    payload = JSON.parse(data);
  } catch {
    return null;
  }

  // unknown events are ignored, as the backend asks
  if (event === 'status' || event === 'token' || event === 'cards' || event === 'done' || event === 'error') {
    return { event, data: payload } as ChatStreamEvent;
  }
  return null;
}
